import * as Styles from './AssignedInterviewReviewsManager.styles';
import { AssignesUsersType } from '../AssignedUsers';
import { UserSuggestionsType } from '../UserSuggestions';

type AssignedInterviewReviewsManagerType = AssignesUsersType & UserSuggestionsType;

export default function AssignedInterviewReviewsManagerComponent({
  reviewersSuggestions,
  onAssign,
  isUserReviewer,
  onAssignToMyself,
  onRemoveAssignedUser,
  assignedUsers,
  allReviewers,
}: AssignedInterviewReviewsManagerType): JSX.Element {
  return (
    <div>
      <Styles.SessionTitle>Reviewers</Styles.SessionTitle>
      <Styles.Container>
        <Styles.CustomAssignedUsers
          isUserReviewer={isUserReviewer}
          onRemoveAssignedUser={onRemoveAssignedUser}
          onAssignToMyself={onAssignToMyself}
          assignedUsers={assignedUsers}
          allReviewers={allReviewers}
          onAssign={onAssign}
          placeholder="Search for a reviewer"
        />
        <Styles.CustomUserSuggestions
          onAssign={onAssign}
          reviewersSuggestions={reviewersSuggestions}
        />
      </Styles.Container>
    </div>
  );
}
